import React, { useEffect } from 'react'
import { SideBar } from './SideBar'
import { useUser } from '@ztechapps/common.hook'
import includes from 'lodash/includes'
import { paymePermissions } from '@ztechapps/totalmilk-payme.common'
import { PrivateLayout as PrivateLayoutCore } from '@ztechapps/webui.page'
import { HeaderBar } from './header-bar/HeaderBar'
import { CenterScreen, LoadingContent } from '@ztechapps/webui.util'
import { useAppContext } from '../hooks/useAppContext'

export const PrivateLayout = () => {
  const { user, isActive, hasTenant, loading, logout } = useUser()

  const roles = user?.roles
  const hasAppAccess = includes(roles, paymePermissions.app.canAccess.value)
  const { toggleSidebar } = useAppContext()

  useEffect(() => {
    //not yet loaded so do nothing
    if (!user || loading) return

    if (!hasAppAccess || !hasTenant || !isActive) {
      logout()
    }
  }, [hasAppAccess, logout, isActive, hasTenant, user, loading])

  if (!user || loading)
    return (
      <CenterScreen>
        <LoadingContent message={`Loading....`} subMessage="Please wait while we are loading the screen..." />
      </CenterScreen>
    )

  return (
    <div className={toggleSidebar.showClassName}>
      <PrivateLayoutCore sidebar={<SideBar />} header={<HeaderBar />} />
    </div>
  )
}
